import { NgModule } from '@angular/core';
import { DatePipe } from "@angular/common";
import { SharedModule } from '../shared/shared.module';
import { InboxComponent } from './inbox.component';
import { NotificationsModule } from "../notifications/notifications.module";
import { NewsModule } from '../news/news.module';

@NgModule({
    imports: [
        SharedModule,
        NotificationsModule,
        NewsModule,
    ],
    declarations: [
        InboxComponent,
    ],
    exports: [
    ],
    providers: [
        DatePipe
    ]
})
export class InboxModule { }
